import { Component } from '.';
import { TransformPosition } from '../../interfaces';

export class Text extends Component {
	public state: {
		text: string;
		color?: string;
		fontSize?: number;
		fontFamily?: string;
		fontWeight?: string;
		fontStyle?: string;
		border?: number;
		backgroundColor?: string;
		borderColor?: string;
		borderRadius?: number;
		padding?: number | Array<number>;
		alignment?: 'left' | 'center' | 'right';
		position: TransformPosition;
	} = { position: { x: 0, y: 0, z: 0 }, text: 'Text' };
}
